/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { useParams } from 'react-router-dom'
import { PlatformList } from '@/components/PlatformList'
import { TPlatformListService } from '@/components/PlatformList/interface'
import { useRolesColumns } from '@/pages/auth/AccessManager/Roles/useRolesColumns'
import { service } from '@/services/service'

export function Roles(
  props: React.PropsWithoutRef<{
    scene: 'contract' | 'billing'
  }>,
) {
  const { scene } = props
  const { contractId } = useParams()
  const columns = useRolesColumns()
  const emitter = PlatformList.useCreateEmitter()

  const getRolesService: TPlatformListService = () => {
    return service.getContractRoles(contractId, scene)
  }

  // ant design 会默认将 children 属性渲染为可展开的表格，这里将 children 属性改为 unknown
  return (
    <PlatformList
      emitter={emitter}
      service={getRolesService}
      columns={columns}
      rowKey={record => record.name}
      pagination={false}
      expandable={{ childrenColumnName: 'unknown' }}
    />
  )
}
